import React from 'react';

interface CodeFormatterProps {
  value: React.ReactNode;
}

const CodeFormatter: React.FC<CodeFormatterProps> = ({ value }) => {
  return <pre>{value}</pre>;
};

export default CodeFormatter;
